import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "CounterpartyRisk" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
